import React from 'react'
import moment from 'moment'
import { Icon } from 'antd'
import * as styles from './index.scss'
import fbtn from '../../assets/images/five_btn.png'
import sbtn from '../../assets/images/six_btn.png'

interface Props {
  id: number
  cover: string
  name: string
  region: string
  depart: string
  intro: string
  time: number
  desc: string
  color?: { r: number; g: number; b: number }
  broken: boolean
  six?: boolean
  onClick: React.EventHandler<any>
}

const FiveStar: React.SFC<Props> = ({
  id,
  cover,
  name,
  region,
  depart,
  intro,
  time,
  desc,
  six = false,
  broken,
  onClick,
}) => {
  const breakline = (width?) => (
    <div
      style={{
        width,
        backgroundColor: six ? '#FFCD20' : '#FCBABA',
      }}
      className={styles.breakLine}
    />
  )

  const breakavatar = (
    <div
      className={styles.breakfiveAvatar}
      style={{
        borderColor: six && '#FFCD20',
      }}
    >
      <div
        className={styles.breakfiveUnknown}
        style={{
          backgroundColor: six && '#FFF4BF',
          color: six && '#FDCB1B',
        }}
      >
        ?
      </div>
    </div>
  )
  return (
    <div className={styles.starfive}>
      <div className={styles.starfiveTip}>{six ? '六' : '五'}星</div>
      <div className={styles.starfiveTop}>
        <div className={styles.starfiveTopInfo}>
          <div className={styles.starfiveTopInfoName}>
            {broken ? '空缺' : name}
          </div>
          {broken ? (
            <div>
              {breakline(100)}
              {breakline(130)}
              {breakline(140)}
            </div>
          ) : (
            <>
              <div className={styles.starfiveTopInfoDesc}>
                <span>单位：{`${region} ${depart}`}</span>
              </div>
              <div className={styles.starfiveTopInfoDesc}>
                <span>晋级：{moment(time * 1000).format('YYYY-MM-DD')}</span>
              </div>
            </>
          )}
        </div>
        {broken ? (
          breakavatar
        ) : (
          <div className={styles.starfiveAvatar}>
            <div
              style={{
                backgroundImage: `url(${cover})`,
                backgroundPosition: 'top center',
                width: 130,
                height: 153,
              }}
            />
          </div>
        )}
      </div>
      <div>
        <div className={styles.starfiveIntro}>
          <div className={styles.starfiveIntroTitle}>
            <span>讲师介绍</span>
          </div>
          <div className={styles.starfiveIntroContent} title={intro}>
            {broken ? (
              <div>
                {breakline('80%')}
                {breakline('50%')}
                {breakline(140)}
              </div>
            ) : (
              intro
            )}
          </div>
        </div>
        <div className={styles.starfiveDesc}>
          <span>{desc}</span>
          <div className={styles.starfiveDescTitle}>宣言</div>
        </div>
        <div
          className={broken || id ? styles.starfiveBtn : styles.breakfiveBtn}
          style={{
            cursor: id ? 'pointer' : 'no-drop',
          }}
          onClick={id && onClick}
        >
          <img src={six ? sbtn : fbtn} width="100%" />
          <div className={styles.starfiveBtnTitle}>
            <span style={{ marginRight: 8 }}>
              {broken
                ? `下一个${six ? '六' : '五'}星上将会是你吗？`
                : '成长故事'}
            </span>
            <Icon type="right" style={{ fontSize: 16 }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FiveStar
